import { Patient } from '@dreryk/egabinet-patient-frontend-api';

import { FormRouteLeavingPrompt } from '@dreryk/react-components';

import { usePersonalDataFormController } from '../../common/common.hooks';
import { PersonalDataFormController } from '../../common/common.types';
import { selectInitialPersonalData } from '../../common/common.utils';
import { ContactDetailsFormSection } from '../../common/ContactDetailsFormSection';
import { PersonalDataFormSection } from '../../common/PersonalDataFormSection';
import { EntitlementStatementsSection } from '../../entitlementStatements/EntitlementStatementsSection';
import { IdentityDocumentFormSection } from '../../identityDocument/IdentityDocumentFormSection';

import { AppointmentOutOfScheduleAction } from './AppointmentOutOfScheduleAction';
import { PatientConfirmedUpdateAction } from './PatientConfirmedUpdateAction';
import { AdditionalEntitlementsFormSection } from './sections/AdditionalEntitlementsFormSection/AdditionalEntitlementsFormSection';
import { PatientGuardians } from './sections/PatientGuardiansSection/PatientGuardians/PatientGuardians';
import { StyledPatientUpdatePersonalData } from './StyledPatientUpdatePersonalData';

type PersonalDataProps = {
   readonly patient: Patient;
};

export const PatientConfirmedUpdatePersonalData = (props: PersonalDataProps): JSX.Element => {
   const {
      handleSubmit,
      register,
      setValue,
      formState,
      watch,
      trigger,
      setError,
      reset,
      getValues,
   }: PersonalDataFormController = usePersonalDataFormController(selectInitialPersonalData(props.patient));

   const patientMedicalRecordNumber = props.patient.referenceIdentifier?.findMedicalRecordNumber() ?? null;

   return (
      <StyledPatientUpdatePersonalData>
         <PersonalDataFormSection
            register={register}
            watch={watch}
            setValue={setValue}
            setError={setError}
            trigger={trigger}
            reset={reset}
            getValues={getValues}
            formState={formState}
            patientId={props.patient.id}
            patientMedicalRecordNumber={patientMedicalRecordNumber}
            withGuardians
         />
         <ContactDetailsFormSection register={register} watch={watch} />
         <IdentityDocumentFormSection name={'identityDocument'} register={register} watch={watch} setValue={setValue} />
         <AdditionalEntitlementsFormSection patientId={props.patient.id} />
         <EntitlementStatementsSection patientId={props.patient.id} />
         <PatientGuardians patientId={props.patient.id} setValue={setValue} watch={watch} />
         <AppointmentOutOfScheduleAction patientId={props.patient.id} formState={formState} />
         <PatientConfirmedUpdateAction
            handleSubmit={handleSubmit}
            patientId={props.patient.id}
            disabled={!formState.isDirty}
            patientMedicalRecordNumber={patientMedicalRecordNumber}
         />
         <FormRouteLeavingPrompt formState={formState} />
      </StyledPatientUpdatePersonalData>
   );
};
